// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRequestedRequestsTableHeader_root__bBjAS","heading":"CoursePauseRequestedRequestsTableHeader_heading__pPF8H"};